import React from "react"
import GuestsPage from "./guests"

export default GuestsPage;
